import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { authFetch } from "../../utils/api";
import '../../styles/admin/admin-form.css'; 

export default function FormularioRuta() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id); 

  const [formData, setFormData] = useState({
    nombre: '',
    estaciones: [] // Array de objetos Estacion
  });
  
  // Lista completa de estaciones para seleccionar
  const [allEstaciones, setAllEstaciones] = useState([]);
  const [selectedEstacionId, setSelectedEstacionId] = useState('');

  const [pageLoading, setPageLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setPageLoading(true);
        // 1. Cargar todas las estaciones disponibles para el select
        const resEstaciones = await authFetch(`/api/Estaciones`);
        if (!resEstaciones.ok) throw new Error('Error cargando catálogo de estaciones');
        const dataEstaciones = await resEstaciones.json();
        setAllEstaciones(dataEstaciones);

        // 2. Si es editar, cargar la ruta
        if (isEditMode) {
          const resRuta = await authFetch(`/api/RutaFerroviaria/${id}`);
          if (!resRuta.ok) throw new Error('Error cargando la ruta');
          const dataRuta = await resRuta.json();
          setFormData({
            nombre: dataRuta.nombre || '',
            estaciones: dataRuta.estaciones || []
          });
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setPageLoading(false);
      }
    };
    loadData();
  }, [id, isEditMode]);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // Función para añadir una estación a la lista local
  const handleAddEstacion = () => {
    if (!selectedEstacionId) return;

    // Verificar si ya existe en la lista
    const yaExiste = formData.estaciones.some(e => e.id === selectedEstacionId);
    if (yaExiste) {
      alert("Esta estación ya está agregada a la ruta.");
      return;
    }

    const estacionObj = allEstaciones.find(e => e.id === selectedEstacionId);
    if (estacionObj) {
      setFormData(prev => ({
        ...prev,
        estaciones: [...prev.estaciones, estacionObj]
      }));
      setSelectedEstacionId(''); // Reset select
    }
  };

  const handleRemoveEstacion = (index) => {
    setFormData(prev => ({
      ...prev,
      estaciones: prev.estaciones.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    
    const payload = {
      ...(isEditMode && { id }),
      nombre: formData.nombre,
      estaciones: formData.estaciones
    };

    const url = isEditMode
      ? `/api/RutaFerroviaria/${id}`
      : `/api/RutaFerroviaria`;
    const method = isEditMode ? 'PUT' : 'POST';

    try {
      const response = await authFetch(url, {
        method: method,
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const txt = await response.text();
        throw new Error(txt || 'Error al guardar ruta');
      }

      alert('Ruta guardada exitosamente');
      navigate('/admin/rutas');

    } catch (err) {
      alert('Error: ' + err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-container">
      <button className="btn-back" onClick={() => navigate(-1)} disabled={isSubmitting}>
        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/></svg>
        Volver
      </button>

      <h1>{isEditMode ? 'Editar Ruta' : 'Nueva Ruta'}</h1>

      {error && <div className="form-error">Error: {error}</div>}

      {pageLoading ? (
        <div className="form-loading">Cargando...</div>
      ) : (
        <form onSubmit={handleSubmit}>
          
          <div className="form-group">
            <label htmlFor="nombre">Nombre de la Ruta (*)</label>
            <input
              id="nombre"
              name="nombre"
              type="text"
              placeholder="Ej. Ruta del Golfo"
              value={formData.nombre}
              onChange={handleChange}
              disabled={isSubmitting}
              required
            />
          </div>

          <fieldset>
            <legend>Estaciones de la Ruta</legend>
            
            {/* Selector para añadir estación */}
            <div className="form-row" style={{ alignItems: 'flex-end' }}>
              <div className="form-group" style={{ flex: 1 }}>
                <label>Agregar Estación</label>
                <select 
                  value={selectedEstacionId} 
                  onChange={(e) => setSelectedEstacionId(e.target.value)}
                  disabled={isSubmitting}
                >
                  <option value="">-- Seleccione una estación --</option>
                  {allEstaciones.map(est => (
                    <option key={est.id} value={est.id}>
                      {est.nombre}
                    </option>
                  ))}
                </select>
              </div>
              <button 
                type="button" 
                className="btn-add-turno" 
                onClick={handleAddEstacion}
                disabled={!selectedEstacionId || isSubmitting}
                style={{ marginBottom: '15px' }}
              >
                + Añadir
              </button>
            </div>

            {/* Lista de estaciones agregadas */}
            {formData.estaciones.length === 0 && (
              <p className="horario-cerrado">No hay estaciones asignadas a esta ruta.</p>
            )}

            {formData.estaciones.map((est, index) => (
              <div key={index} className="horario-turno" style={{ alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <strong>{est.nombre}</strong> <br/>
                  <span style={{ fontSize: '0.85em', color: '#666' }}>
                    Lat: {est.latitud}, Lon: {est.longitud}
                  </span>
                </div>
                <button 
                  type="button" 
                  onClick={() => handleRemoveEstacion(index)} 
                  className="btn-remove-turno" 
                  title="Quitar de la ruta"
                  disabled={isSubmitting}
                >
                  &times;
                </button>
              </div>
            ))}
          </fieldset>

          <button 
            type="submit" 
            className="btn-submit" 
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Guardando...' : 'Guardar Ruta'}
          </button>
        </form>
      )} 
    </div>
  );
}